import { Event } from '../types';

export const events: Event[] = [
  {
    id: '1',
    title: 'Summer Music Festival',
    description: 'A three-day music festival featuring top artists from around the world.',
    imageUrl: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
    venue: 'Central Park',
    city: 'New York',
    date: '2025-07-15',
    time: '12:00 PM',
    price: 150,
    category: 'concert',
    availableTickets: 500,
    ticketUrl: 'https://www.ticketmaster.com/summer-music-festival-tickets/event/0C005A9A8A5A1234'
  },
  {
    id: '2',
    title: 'Tech Conference 2025',
    description: 'The biggest tech conference of the year with keynotes from industry leaders.',
    imageUrl: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
    venue: 'Convention Center',
    city: 'San Francisco',
    date: '2025-09-20',
    time: '9:00 AM',
    price: 299,
    category: 'conference',
    availableTickets: 1000,
    ticketUrl: 'https://www.eventbrite.com/tech-conference-2025-tickets/event/0C005A9A8A5A5678'
  },
  {
    id: '3',
    title: 'Broadway Show: Hamilton',
    description: 'The award-winning musical about the life of American Founding Father Alexander Hamilton.',
    imageUrl: 'https://images.unsplash.com/photo-1503095396549-807759245b35?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1741&q=80',
    venue: 'Richard Rodgers Theatre',
    city: 'New York',
    date: '2025-06-10',
    time: '7:00 PM',
    price: 200,
    category: 'theater',
    availableTickets: 300,
    ticketUrl: 'https://www.broadway.com/hamilton-tickets/event/0C005A9A8A5A9012'
  },
  {
    id: '4',
    title: 'NBA Finals Game 1',
    description: 'The first game of the NBA Finals championship series.',
    imageUrl: 'https://images.unsplash.com/photo-1504450758481-7338eba7524a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1769&q=80',
    venue: 'Madison Square Garden',
    city: 'New York',
    date: '2025-06-05',
    time: '8:00 PM',
    price: 350,
    category: 'sports',
    availableTickets: 200,
    ticketUrl: 'https://www.nba.com/tickets/finals-game-1/event/0C005A9A8A5A3456'
  },
  {
    id: '5',
    title: 'Food & Wine Festival',
    description: 'A culinary celebration featuring top chefs and wineries from around the world.',
    imageUrl: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
    venue: 'Waterfront Park',
    city: 'Chicago',
    date: '2025-08-12',
    time: '11:00 AM',
    price: 85,
    category: 'festival',
    availableTickets: 750,
    ticketUrl: 'https://www.foodandwine.com/festival-tickets/event/0C005A9A8A5A7890'
  },
  {
    id: '6',
    title: 'Electronic Dance Music Festival',
    description: 'A weekend of electronic music featuring world-renowned DJs.',
    imageUrl: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
    venue: 'Beachfront Arena',
    city: 'Miami',
    date: '2025-03-25',
    time: '4:00 PM',
    price: 175,
    category: 'concert',
    availableTickets: 1000,
    ticketUrl: 'https://www.ultramusicfestival.com/tickets/event/0C005A9A8A5A2345'
  },
  {
    id: '7',
    title: 'Comic Convention',
    description: 'The ultimate fan experience with celebrity guests, panels, and exclusive merchandise.',
    imageUrl: 'https://images.unsplash.com/photo-1608889476561-6242cfdbf622?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
    venue: 'Convention Center',
    city: 'San Diego',
    date: '2025-07-22',
    time: '10:00 AM',
    price: 120,
    category: 'conference',
    availableTickets: 5000,
    ticketUrl: 'https://www.comic-con.org/tickets/event/0C005A9A8A5A6789'
  },
  {
    id: '8',
    title: 'Classical Music Concert',
    description: 'A night of classical masterpieces performed by the Symphony Orchestra.',
    imageUrl: 'https://images.unsplash.com/photo-1465847899084-d164df4dedc6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
    venue: 'Symphony Hall',
    city: 'Boston',
    date: '2025-05-15',
    time: '7:30 PM',
    price: 95,
    category: 'concert',
    availableTickets: 400,
    ticketUrl: 'https://www.bostonsymphony.org/tickets/event/0C005A9A8A5A8901'
  }
];

export const cities = [...new Set(events.map(event => event.city))];
export const categories = [...new Set(events.map(event => event.category))];